var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinally(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9741 2.47153C15.2937 -0.855859 10.6141 5.6153 5.93375 3.36474V2.88599C5.93375 2.29141 5.44465 1.80903 4.84183 1.80903C4.23901 1.80903 3.75 2.29141 3.75 2.88599V21.4231C3.75 22.0176 4.23901 22.5 4.84183 22.5C5.44465 22.5 5.93375 22.0176 5.93375 21.4231V13.57C10.3823 15.7084 14.831 9.96844 19.2804 12.2527C19.3814 12.3049 19.4943 12.3305 19.6083 12.3269C19.7222 12.3233 19.8333 12.2907 19.9307 12.2323C20.0283 12.174 20.109 12.0919 20.1649 11.9939C20.2208 11.8959 20.2501 11.7853 20.25 11.6728V3.00229C20.2498 2.89862 20.2247 2.79647 20.1767 2.70421C20.1288 2.61196 20.0593 2.53222 19.9741 2.47153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinally);
export default __webpack_public_path__ + "static/media/finally.195c958692759797ede6380c2a323203.svg";
export { ForwardRef as ReactComponent };